import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import ResponseResult from '../../../shared/responses/ResponseResult';
import EmisorCsdFiscalCredentialsForm from './components/EmisorCsdFiscalCredentialsForm';

class EmisoresCsdUpdate extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data } = props;

    this.state = {
      data: { ...data, series: data.series || [] },
    };

    props.csdActions.setPartialState({
      data: this.state.data,
    });
  }

  componentWillUnmount() {
    this.props.csdActions.reset();
  }

  handleOnFormDataChange = (event) => {
    const {
      data,
      data: { certificados = {} },
    } = this.props.csd;

    const newData = {
      data: {
        ...data,
        certificados: {
          ...certificados,
          ...event.data,
        },
      },
      isValid: event.isValid,
    };

    this.props.csdActions.setPartialState(newData);
  };

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.csdActions.setPartialState({
        error: undefined,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    const { data, result } = this.props.csd;

    if (result && this.props.onComplete) {
      window.ToastManager.show({
        variant: 'success',
        title: 'Completado',
        message: data.message || 'Certificado actualizado',
      });

      this.props.onComplete(data);
    }
  };

  handleOnSubmit = async () => {
    const {
      data: { certificados, id },
    } = this.props.csd;

    const certificates = {
      csd_key: certificados.csd_key && certificados.csd_key.value.content,
      csd_cer: certificados.csd_cer && certificados.csd_cer.value.content,
      csd_password: certificados.csd_password,
      fiel_key: certificados.fiel_key && certificados.fiel_key.value.content,
      fiel_cer: certificados.fiel_cer && certificados.fiel_cer.value.content,
      fiel_password: certificados.fiel_password,
    };

    await this.props.csdActions.update({ certificados: certificates }, id, this.props.livemode);

    const { result } = this.props.csd;

    if (!!result && this.props.onComplete) {
      this.handleOnAction('complete');

      return;
    }
  };

  renderError = () => {
    const { error } = this.props.csd;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result, data } = this.props.csd;

    return (
      <div className="result-container">
        <ResponseResult
          title={data.id ? 'Información actualizada' : 'Registro completado'}
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { data = {}, busy, isValid, error, result } = this.props.csd;
    const { hint, heading, onComplete } = this.props;

    return (
      <>
        {heading}

        {!!error && this.renderError()}

        {!!result && !onComplete && this.renderResult()}

        <div className="pt-3">
          <EmisorCsdFiscalCredentialsForm
            data={data.certificados || {}}
            onFormDataChange={this.handleOnFormDataChange}
          />
        </div>

        {hint}

        <LoadingButton
          type="button"
          loading={busy}
          disabled={!isValid}
          onClick={this.handleOnSubmit}
        >
          {busy ? 'Guardando...' : 'Guardar'}
        </LoadingButton>
      </>
    );
  }
}

const mapState = (store) => {
  return { csd: store.app.emisores.csd };
};

const mapActions = (actions) => {
  return { csdActions: actions.app.emisores.csd };
};

export default connect(useStore, mapState, mapActions)(EmisoresCsdUpdate);
